import type { FormattedPaymentMethod } from '../../shared/types/FormattedPaymentMethod';
import type { PaymentMethodType } from '../../services/customer/types';

const findFormattedPaymentMethod = (
  formattedPaymentMethods: FormattedPaymentMethod<PaymentMethodType>[],
  paymentMethodId: string | null,
) => {
  return paymentMethodId
    ? formattedPaymentMethods.find(
        (paymentMethod) =>
          paymentMethod.paymentMethodId === paymentMethodId,
      ) || null
    : null;
};

export default findFormattedPaymentMethod;
